import * as React from "react";

import {
  SidebarSeparator,
  useSidebar,
} from "@replo/design-system/components/shadcn/core/sidebar";
import twMerge from "@replo/design-system/utils/twMerge";

export function DashboardSidebarSeparator({
  insetRight,
  className,
}: {
  insetRight?: boolean;
  className?: string;
}) {
  // Note (Noah, 2025-08-30): Shadcn sidebar already passes in w-auto here, but that w-auto
  // doesn't override the separator's data-[orientation=horizontal]:w-full, possibly this would
  // be fixed by upgrading twMerge?
  const { open: isSidebarExpanded } = useSidebar();
  return (
    <SidebarSeparator
      className={twMerge(
        "!h-[0.5px] px-0 bg-sidebar-border !w-auto",
        insetRight && isSidebarExpanded && "mr-5",
        className,
      )}
    />
  );
}
